module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<div class=\"separator\"></div>\n<button type=\"button\"><i class=\"fi fi-gears\"></i> Platzhalter für personalisierte E-Mails anzeigen</button>\n<div class=\"variables\">\n<table>\n<tr><td><strong>Platzhalter</strong></td>\t<td><strong>Eingefügter Beispielwert</strong></td></tr>\n<tr><td>{{salutation}}</td>\t\t\t\t\t<td>Sehr geehrte Frau Mustermann</td></tr>\n<tr><td>{{salutation_full}}</td>\t\t\t<td>Sehr geehrte Frau Maria Mustermann</td></tr>\n<tr><td>{{salutation_hello}}</td>\t\t\t<td>Hallo Frau Mustermann</td></tr>\n<tr><td>{{fullName}}</td>\t\t\t\t\t<td>Maria Mustermann</td></tr>\n<tr><td>{{firstName}}</td>\t\t\t\t\t<td>Maria</td></tr>\n<tr><td>{{lastName}}</td>\t\t\t\t\t<td>Mustermann</td></tr>\n<tr><td>{{email}}</td>\t\t\t\t\t\t<td>E-Mail Adresse</td></tr>\n<tr><td>{{segmentFeldName}}</td>\t\t\t<td>Segment-Name liefert Segment-Wert</td></tr>\n</table>\n<br>\n<span><i class=\"fi fi-times\"></i>&nbsp;ausblenden</span>\n</div>\n</div>"
  , __filename = "components/templates/newsletter/mailings/edit/content/variables.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<div class=\"separator\"></div>\n<button type=\"button\"><i class=\"fi fi-gears\"></i> Platzhalter für personalisierte E-Mails anzeigen</button>\n<div class=\"variables\">\n<table>\n<tr><td><strong>Platzhalter</strong></td>	<td><strong>Eingefügter Beispielwert</strong></td></tr>\n<tr><td>{{salutation}}</td>					<td>Sehr geehrte Frau Mustermann</td></tr>\n<tr><td>{{salutation_full}}</td>			<td>Sehr geehrte Frau Maria Mustermann</td></tr>\n<tr><td>{{salutation_hello}}</td>			<td>Hallo Frau Mustermann</td></tr>\n<tr><td>{{fullName}}</td>					<td>Maria Mustermann</td></tr>\n<tr><td>{{firstName}}</td>					<td>Maria</td></tr>\n<tr><td>{{lastName}}</td>					<td>Mustermann</td></tr>\n<tr><td>{{email}}</td>						<td>E-Mail Adresse</td></tr>\n<tr><td>{{segmentFeldName}}</td>			<td>Segment-Name liefert Segment-Wert</td></tr>\n</table>\n<br>\n<span><i class=\"fi fi-times\"></i>&nbsp;ausblenden</span>\n</div>\n</div>")
    ; __line = 19
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/mailings/edit/content/variables.ejs

}